import { Layout } from "../../components/layout/Layout";
import { PageTransition } from "../../components/layout/PageTransition";
import { SEO } from "../../components/SEO";
import { HeroSection } from "../../components/home/HeroSection";
import { FeaturesSection } from "../../components/home/FeaturesSection";
import { TestimonialsSection } from "../../components/home/TestimonialsSection";
import { CTASection } from "../../components/home/CTASection";

export default function Home() {
  return (
    <Layout>
      <SEO
        title="Intelligent Automation for Modern Teams"
        description="Kliq CRM empowers your team with AI-powered workflows, seamless integrations, and real-time collaboration."
        keywords="SaaS, automation, workflow, AI, collaboration, productivity"
        hreflang
      />
      <PageTransition>
        <HeroSection />
        <FeaturesSection />
        <TestimonialsSection />
        <CTASection />
      </PageTransition>
    </Layout>
  );
}
